import { MESSAGE_TYPE } from 'shared/constants/messages';
import { applyPageContactFilters as applyPageFilters, sortComparator } from './helpers';
import filterQueryGenerator from 'dashboard/helper/filterQueryGenerator';

// Backend grouped_by_contact filters by *contact* labels; API payload has *conversation* labels.
// So we must not re-filter by conversation.labels here or we drop valid rows.
const filtersWithoutLabelFilter = filters => ({ ...filters, labels: [] });

export const getContactViewSelectedChatConversation = ({
  allContactViewConversations,
  selectedChatId,
  selectedContactId,
}) =>
  allContactViewConversations.filter(conversation => conversation.id === selectedChatId);

const getters = {
  getContactViewAllConversations: ({ allContactViewConversations, chatSortFilter: sortKey }) => {
    return allContactViewConversations.sort((a, b) => sortComparator(a, b, sortKey));
  },
  getContactViewSelectedChat: ({ selectedChatId, allContactViewConversations }) => {
    const selectedChat = allContactViewConversations.find(
      conversation => conversation.id === selectedChatId
    );
    return selectedChat || {};
  },
  getContactViewSelectedChatAttachments: (_state, _getters) => {
    const selectedChat = _getters.getContactViewSelectedChat;
    return selectedChat.attachments || [];
  },
  getContactViewChatListFilters: ({ conversationFilters }) => conversationFilters,
  getContactViewLastEmailInSelectedChat: (stage, _getters) => {
    const selectedChat = _getters.getContactViewSelectedChat;
    const { messages = [] } = selectedChat;
    const lastEmail = [...messages].reverse().find(message => {
      const {
        content_attributes: contentAttributes = {},
        message_type: messageType,
      } = message;
      const { email = {} } = contentAttributes;
      const isIncomingOrOutgoing =
        messageType === MESSAGE_TYPE.OUTGOING ||
        messageType === MESSAGE_TYPE.INCOMING;
      if (email.from && isIncomingOrOutgoing) {
        return true;
      }
      return false;
    });

    return lastEmail;
  },
  getContactViewMineChats: (_state, _, __, rootGetters) => activeFilters => {
    const currentUserID = rootGetters.getCurrentUser?.id;
    const filters = filtersWithoutLabelFilter(activeFilters);
    return _state.allContactViewConversations.filter(conversation => {
      const { assignee } = conversation.meta;
      const isAssignedToMe = assignee && assignee.id === currentUserID;
      const shouldFilter = applyPageFilters(conversation, filters);
      const isChatMine = isAssignedToMe && shouldFilter;

      return isChatMine;
    });
  },
  getContactViewAppliedConversationFilters: _state => {
    return _state.appliedFilters;
  },
  getContactViewAppliedConversationFiltersQuery: _state => {
    const hasAppliedFilters = _state.appliedFilters.length !== 0;
    return hasAppliedFilters ? filterQueryGenerator(_state.appliedFilters) : [];
  },
  getContactViewUnAssignedChats: _state => activeFilters => {
    const filters = filtersWithoutLabelFilter(activeFilters);
    return _state.allContactViewConversations.filter(conversation => {
      const isUnAssigned = !conversation.meta.assignee;
      const shouldFilter = applyPageFilters(conversation, filters);
      return isUnAssigned && shouldFilter;
    });
  },
  getContactViewAllStatusChats: _state => activeFilters => {
    const filters = filtersWithoutLabelFilter(activeFilters);
    return _state.allContactViewConversations.filter(conversation => {
      const shouldFilter = applyPageFilters(conversation, filters);
      return shouldFilter;
    });
  },
  getContactViewChatListLoadingStatus: ({ listLoadingStatus }) => listLoadingStatus,
  getContactViewAllMessagesLoaded(_state) {
    const [chat] = getContactViewSelectedChatConversation(_state);
    return !chat || chat.allMessagesLoaded === undefined
      ? false
      : chat.allMessagesLoaded;
  },
  getContactViewUnreadCount(_state) {
    const [chat] = getContactViewSelectedChatConversation(_state);
    if (!chat) return [];
    return chat.messages.filter(
      chatMessage =>
        chatMessage.created_at * 1000 > chat.agent_last_seen_at * 1000 &&
        chatMessage.message_type === 0 &&
        chatMessage.private !== true
    ).length;
  },
  getContactViewChatStatusFilter: ({ chatStatusFilter }) => chatStatusFilter,
  getContactViewChatSortFilter: ({ chatSortFilter }) => chatSortFilter,
  getContactViewSelectedInbox: ({ currentInbox }) => currentInbox,
  getContactViewConversationById: _state => conversationId => {
    return _state.allContactViewConversations.find(
      value => value.id === Number(conversationId)
    );
  },
  /** Same shape as conversations module — mutations expect this name. */
  getConversationById: _state => conversationId => {
    return _state.allContactViewConversations.find(
      value => value.id === Number(conversationId)
    );
  },
  getContactViewConversationParticipants: _state => {
    return _state.conversationParticipants;
  },
  getContactViewConversationLastSeen: _state => {
    return _state.conversationLastSeen;
  },

  getContactViewContextMenuChatId: _state => {
    return _state.contextMenuChatId;
  },
};

export default getters;
